// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"UserFinder_searchWrapper__1odVG","results":"UserFinder_results__iyij2","table":"UserFinder_table__8C_vR"};